<script>
import * as layouts from "./layouts";

export default {
  functional: true,
  name: "BaseForm",
  render(h, context) {
    if (context.props.formData) {
      context.data.attrs.model = context.props.formData;
    }

    if (!context.data.attrs.labelWidth) {
      context.data.attrs.labelWidth = 120;
    }

    context.data.attrs.labelColon = true;

    return h("Form", context.data, [layouts.createRow.call(context, h)]);
  },
  props: {
    formData: Object,
    span: Number,
    showDetails: Boolean,
    columns: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
};
</script>

<style lang="less">
.lb_form_show_details_main {
  .ivu-form-item {
    margin-bottom: 5px;
  }
}
</style>
